<div class="results-section"
  [ngClass]="{'en': currentLanguage === 'en' && activeTabIndex===TabId.LIST, 'he': currentLanguage === 'he' && activeTabIndex===TabId.LIST}">
  <div class="results">
    <div class="results-body">
      <div class="results-inner full-height">
        <div class="results-body-inner full-height">
          <div class="card results-card-relative">

            <!-- Filter button (always visible when there are results, regardless of toggle state) -->
            <!-- Hidden per user request: hide entity types filter button and toggle, and always show as if toggle is false -->
            <button *ngIf="useOriginalFilterBehavior && !isLoading && totalAvailableCount > 0"
              #filterBtn
              class="filter-open-btn header-filter-btn"
              [ngClass]="{'he': currentLanguage === 'he', 'en': currentLanguage === 'en'}"
              [class.is-filtered]="selectedAvailableCount < totalAvailableCount"
              [attr.aria-haspopup]="'dialog'"
              [attr.aria-expanded]="isFilterDialogOpen"
              [attr.aria-label]="('iaa.app.results.filterButton' | translate) + ' ' + selectedAvailableCount + ' ' + ('iaa.app.results.outOf' | translate) + ' ' + totalAvailableCount"
              (click)="openFilterDialog()">
              <span class="filter-btn-label">{{ 'iaa.app.results.filterButton' | translate }}</span>
              <span class="filter-btn-badge">{{ selectedAvailableCount }}/{{ totalAvailableCount }}</span>
              <img src="assets/icons/filter-more.svg" class="filter-btn-icon" aria-hidden="true" alt="" />
            </button>

            <p-tabView #tabView [(activeIndex)]="activeTabIndex" ariaLabelTarget
              targetSelector=".p-tabview-nav[role='tablist']" (onChange)="handleChange($event)"
              [ariaLabelText]="'iaa.app.results.selectDisplay' | translate">

              <div [ngClass]="{'results-header': true, 'en': currentLanguage === 'en', 'he': currentLanguage === 'he'}">

                <!-- Switches row -->
                <div class="show-with-img" *ngIf="!isLoading">
                  <div class="picSwitchContainer" *ngIf="totalAvailableCount > 0">
                    <div class="switch-group">
                      <!-- Hidden per user request: hide entity types filter button and toggle, and always show as if toggle is false -->
                      <div class="switch-wrapper" *ngIf="useOriginalFilterBehavior">
                        <p-inputSwitch inputId="preferred-sources-switch"
                          [(ngModel)]="filterEnabled"
                          (onChange)="toggleFilterEnabled()" />
                        <label for="preferred-sources-switch">
                          {{'iaa.app.results.preferredSourcesOnly' | translate}}
                        </label>
                      </div>
                      <div class="switch-wrapper">
                        <p-inputSwitch inputId="image-switch"
                          [(ngModel)]="withImagesOnly"
                          (onChange)="toggleShowOnlyWithImages()" />
                        <label class="pic-switch-label" for="image-switch">{{'iaa.app.results.resultsImageOnly' | translate}}</label>
                      </div>
                    </div>
                    <button *ngIf="shouldDisplayClearFilter()"
                      class="clear-filter-btn"
                      (click)="clearFilters()">
                      <img src="assets/icons/filter-remove.svg" class="clear-filter-icon" aria-hidden="true" alt="" />
                      <span>{{ 'iaa.app.results.clearFilters' | translate }}</span>
                    </button>
                  </div>
                </div>

                <!-- Tag strip -->
                <div class="total-results" *ngIf="!isLoading">
                  <div aria-live="polite" aria-atomic="true" class="sr-only">
                    {{ filterEnabled ? selectedFilteredCount : totalAuthorizedCount }}
                    {{ 'iaa.app.results.outOf' | translate }} {{ totalAuthorizedCount }}
                  </div>

                  <div [ngClass]="{'results-counts mb': true, 'en': currentLanguage === 'en', 'he': currentLanguage === 'he'}"
                    *ngIf="entities.length">
                    <div [ngClass]="{'results-counts': true, 'en': currentLanguage === 'en', 'he': currentLanguage === 'he'}"
                      role="group" [attr.aria-label]="'iaa.app.results.showResults' | translate">

                      <!-- "All" tag — always shown when there is more than one type -->
                      <div *ngIf="totalAvailableCount > 1"
                        tabindex="0" role="button"
                        class="filter-tag all-tag"
                        [class.activated]="isAllTagActive"
                        [attr.aria-pressed]="isAllTagActive"
                        [attr.aria-label]="('iaa.app.results.all' | translate) + ' (' + selectedFilteredCount + ')'"
                        (click)="clearTagActivations()"
                        (keydown.enter)="clearTagActivations()"
                        (keydown.space)="$event.preventDefault(); clearTagActivations()">
                        <img src="assets/icons/all-more.svg"
                          class="all-tag-icon"
                          [ngClass]="{'en': currentLanguage === 'en', 'he': currentLanguage === 'he'}"
                          aria-hidden="true" alt="" />
                        <span *ngIf="!useOriginalFilterBehavior">
                          {{ ('iaa.app.results.all' | translate) + '(' + totalAuthorizedCount + ')' }}
                        </span>
                        <span *ngIf="useOriginalFilterBehavior">
                          {{ ('iaa.app.results.all' | translate) + '(' + (filterEnabled ? selectedFilteredCount : totalAuthorizedCount) + ')' }}
                        </span>
                        <img src="assets/icons/double-check.svg"
                          class="done-all-icon"
                          [style.visibility]="isAllTagActive ? 'visible' : 'hidden'"
                          aria-hidden="true" alt="" />
                      </div>

                      <!-- Individual tags:
                           Toggle ON  → only selectedTypes that have results
                           Toggle OFF → all returned types -->
                      <ng-container *ngFor="let count of authorizedCounts | keyvalue: alphabeticOrder">
                        <div *ngIf="visibleTagTypes.includes(count.key)"
                          class="filter-tag"
                          [class.activated]="useOriginalFilterBehavior ? activatedTags.includes(count.key) : selectedTypes.includes(count.key)"
                          tabindex="0"
                          role="checkbox"
                          [attr.aria-checked]="useOriginalFilterBehavior ? activatedTags.includes(count.key) : selectedTypes.includes(count.key)"
                          [attr.aria-labelledby]="'filter-tag-' + count.key"
                          (click)="toggleTagActivation(count.key)"
                          (keydown.enter)="toggleTagActivation(count.key)"
                          (keydown.space)="$event.preventDefault(); toggleTagActivation(count.key)">
                          <span [attr.id]="'filter-tag-' + count.key">
                            {{ (getEntityTypeName(count.key) | translateLang | async) + '(' + count.value + ')' }}
                          </span>
                          <img src="assets/icons/double-check.svg"
                            class="done-all-icon"
                            [style.visibility]="(useOriginalFilterBehavior ? activatedTags.includes(count.key) : selectedTypes.includes(count.key)) ? 'visible' : 'hidden'"
                            aria-hidden="true" alt="" />
                        </div>
                      </ng-container>

                    </div>
                  </div>

                  <div class="total" *ngIf="isLoadingMoreResults"
                    [ngClass]="{'en': currentLanguage === 'en', 'he': currentLanguage === 'he'}">
                    <i class="pi pi-spin pi-spinner" style="margin-right: 8px;"></i>
                    {{ 'iaa.app.results.loadingMore' | translate }}
                  </div>

                  <div *ngIf="unauthorizedLicenses.length && numberOfAllEntitiesUnauthorized > 0"
                    [ngClass]="{'unauthorized': true, 'en': currentLanguage === 'en', 'he': currentLanguage === 'he'}">
                    <img src="assets/view-restriction-icon.svg" class="unauthorized-icon" alt="Untauthorized Icon">
                    <div [ngClass]="{'unauthorized-text': true, 'en': currentLanguage === 'en', 'he': currentLanguage === 'he'}">
                      {{ 'iaa.app.results.licensesNotDisplayed' | translate: {numberOfAllEntitiesUnauthorized} }}
                      <button class="unauthorized-link" (click)="handleOpenDialog()" (keydown.enter)="handleOpenDialog()" tabindex="0">
                        <span class="unauthorized-link">{{'iaa.app.results.viewListLicenses' | translate}}</span> &gt;
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <p-tabPanel>
                <ng-template pTemplate="header">
                  <span class="sr-only">{{'iaa.aria.listView' | translate}}</span>
                  <i class="pi pi-list" aria-hidden="true"></i>
                </ng-template>
                <app-results-body-list
                  [isLoading]="isLoading"
                  [isLoadingMoreResults]="isLoadingMoreResults"
                  [isErrorTooManyRows]="isErrorTooManyRows"
                  [isErrorNoPolygons]="isErrorNoPolygons"
                  [entityIndex]="getEntityIndex()"
                  [entities]="filteredEntities"
                  [currentLanguage]="currentLanguage" />
              </p-tabPanel>

              <p-tabPanel>
                <ng-template pTemplate="header">
                  <span class="sr-only">{{'iaa.app.results.tableView' | translate}}</span>
                  <i class="pi pi-table" aria-hidden="true"></i>
                </ng-template>
                <app-results-body-table #rbt
                  (filterFromMap)="handleFilterFromMap($event)"
                  [isLoading]="isLoading"
                  [isLoadingMoreResults]="isLoadingMoreResults"
                  [isErrorTooManyRows]="isErrorTooManyRows"
                  [isErrorNoPolygons]="isErrorNoPolygons"
                  [entityIndex]="getEntityIndex()"
                  [entities]="entities"
                  [currentLanguage]="currentLanguage"
                  (updateFilteredEntities)="updateFilteredEntities($event)" />
              </p-tabPanel>

              <p-tabPanel>
                <ng-template pTemplate="header">
                  <span class="sr-only">{{'iaa.aria.mapView' | translate}}</span>
                  <img src="assets/entity-location-blue.svg" alt="Map Icon" width="17" height="19" class="map-icon map-icon-white" />
                  <img src="assets/entity-location-white.svg" alt="Map Icon" width="17" height="19" class="map-icon map-icon-blue" />
                </ng-template>
                <app-results-body-map
                  [isLoading]="isLoading"
                  [isErrorTooManyRows]="isErrorTooManyRows"
                  [isErrorNoPolygons]="isErrorNoPolygons"
                  [entities]="filteredEntities"
                  [selectedEntityTypes]="selectedTypes"
                  [isAllSelected]="isAllSelected"
                  (handleMapClick)="handleMapClick($event)"
                  (entityTypesChanged)="handleEntityTypesChangedFromMap($event)" />
              </p-tabPanel>

            </p-tabView>
          </div>
        </div>
      </div>

      <!-- Filter Type Dialog -->
      <p-dialog
        [header]="('iaa.app.results.filterDialogTitle' | translate) + ' (' + selectedFilteredCount + ' ' + ('iaa.app.results.selectedResults' | translate) + ' ' + ('iaa.app.results.outOf' | translate) + ' ' + totalAuthorizedCount + ')'"
        [(visible)]="isFilterDialogOpen"
        [modal]="true"
        [dismissableMask]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{ width: '920px', 'max-height': '80vh' }"
        styleClass="filter-dialog"
        (onShow)="onFilterDialogShow()"
        (onHide)="onFilterDialogHide()">
        <div class="filter-dialog-body">
          <div class="filter-dialog-grid"
            role="group"
            [attr.aria-label]="'iaa.app.results.filterDialogTitle' | translate">
            <ng-container *ngFor="let type of sortedDialogOrder">
              <div class="filter-dialog-item" [class.type-no-results]="!authorizedCounts[type]">
                <p-checkbox
                  [inputId]="'cb-' + type"
                  name="typeFilter"
                  [value]="type"
                  [disabled]="!authorizedCounts[type]"
                  [(ngModel)]="dialogSelectedTypes">
                </p-checkbox>
                <label [for]="'cb-' + type" class="filter-dialog-label">
                  {{ (getEntityTypeName(type) | translateLang | async) }}
                  <span class="dialog-type-count" [class.no-results]="!authorizedCounts[type]">
                    ({{ authorizedCounts[type] || 0 }})
                  </span>
                </label>
              </div>
            </ng-container>
          </div>
        </div>
        <ng-template pTemplate="footer">
          <div class="filter-dialog-footer">
            <button class="select-all-link" type="button"
              (click)="selectAllTypes()" (keydown.enter)="selectAllTypes()">
              <i class="pi pi-check select-all-link-icon" aria-hidden="true"></i>
              <span class="select-all-link-text">{{ 'iaa.app.results.filterDialogSelectAll' | translate }}</span>
            </button>
            <button class="select-all-link" type="button"
              (click)="unselectAllTypes()" (keydown.enter)="unselectAllTypes()">
              <i class="pi pi-delete-left select-all-link-icon" aria-hidden="true"></i>
              <span class="select-all-link-text">{{ 'iaa.app.results.filterDialogUnselectAll' | translate }}</span>
            </button>
            <button class="select-all-link" type="button"
              (click)="restoreDefaultsInDialog()" (keydown.enter)="restoreDefaultsInDialog()">
              <i class="pi pi-refresh select-all-link-icon" aria-hidden="true"></i>
              <span class="select-all-link-text">{{ 'iaa.app.results.filterDialogRestoreDefaults' | translate }}</span>
            </button>
            <p-button
              [label]="'iaa.app.results.filterDialogConfirm' | translate"
              (click)="confirmFilterDialog()" />
          </div>
        </ng-template>
      </p-dialog>

      <app-unauthorized-dialog
        [unauthorizedLicenses]="unauthorizedLicenses"
        [isOpen]="isUnauthorizedDialogOpen"
        [currentLanguage]="currentLanguage"
        (onClose)="handleCloseDialog()" />
    </div>
  </div>
</div>